import Helper from "@ember/component/helper"

export function differenceInDays(params) {
  let startDate = dateFns.parse(params[0])
  let endDate = dateFns.parse(params[1] || new Date())
  return dateFns.differenceInDays(startDate, endDate)
}

export default class DifferenceInDays extends Helper {
  compute = differenceInDays
}
